import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '@ui/Button';
import Icon from '@ui/Icon';
import Input, { InputProps } from './Input';

export type PasswordInputProps = Omit<InputProps, 'label' | 'type'> & {
  label?: string;
};

const useStyles = makeStyles<{ fullWidth?: boolean }>()(
  (theme, { fullWidth }) => ({
    iconButton: {
      backgroundColor: theme.palette.ui.input.primary.surface.default,
      color: theme.palette.ui.input.password.icon.default,
      '&.Mui-focusVisible': {
        outline: `2px solid ${theme.palette.ui.input.primary.stroke.focus} !important`,
      },
      '&:hover': {
        color: `${theme.palette.ui.input.password.icon.default} !important`,
      },
      height: '90%',
      top: -2,
      borderRadius: theme.spacing(0.5),
    },
    root: {
      width: fullWidth ? `calc(100% - 32px)` : undefined,
    },
  })
);

const PasswordInput = (props: PasswordInputProps) => {
  const { fullWidth } = props;
  const { label, classes: inputClasses, ...rest } = props;
  const [passwordVisible, setPasswordVisible] = React.useState<boolean>(false);
  const { classes, cx } = useStyles({ fullWidth });

  const toggleVisibility = () => setPasswordVisible(!passwordVisible);

  return (
    // @ts-ignore
    <Input
      {...rest}
      classes={{
        input: cx(classes.root, inputClasses?.input),
        label: inputClasses?.label,
        container: inputClasses?.container,
        div: inputClasses?.div,
      }}
      label={label || 'Password'}
      type={passwordVisible ? 'text' : 'password'}
      endAdornment={
        <Button
          variant="icon"
          aria-label={'Toggle password visibility'}
          onClick={toggleVisibility}
          className={classes.iconButton}
        >
          {passwordVisible ? <Icon type="eye" /> : <Icon type="eyeOff" />}
        </Button>
      }
    />
  );
};

export default PasswordInput;
